(function () {
  'use strict';

  document.querySelectorAll('[data-bundle]').forEach(initBundle);

  function initBundle(root) {
    var bundleSize = parseInt(root.dataset.bundleSize, 10) || 3;
    var bundleType = root.dataset.bundleType || 'mono';
    var discountPct = parseFloat(root.dataset.discountPct) || 10;
    var discountCode = (root.dataset.discountCode || '').trim();

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var bar = root.querySelector('[data-bar]');
    var countEl = root.querySelector('[data-count]');
    var hintEl = root.querySelector('[data-hint]');
    var normalEl = root.querySelector('[data-normal]');
    var bundleEl = root.querySelector('[data-bundle-price]');
    var saveEl = root.querySelector('[data-save]');
    var ctaEl = root.querySelector('[data-cta]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var spinner = root.querySelector('[data-spinner]');

    var selection = {};

    function getMaxQty(card) {
      var v = parseInt(card.dataset.maxQty, 10);
      if (isNaN(v) || v < 0) return 99;
      return v;
    }

    function totalQty() {
      var t = 0;
      Object.keys(selection).forEach(function (k) { t += selection[k].qty; });
      return t;
    }

    function formatMoney(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' €';
    }

    function render() {
      var total = totalQty();
      var subtotal = 0;
      Object.keys(selection).forEach(function (k) {
        subtotal += selection[k].price * selection[k].qty;
      });
      var bundlePrice = Math.round(subtotal * (1 - discountPct / 100));
      var save = subtotal - bundlePrice;

      if (countEl) countEl.textContent = String(total);
      if (normalEl) normalEl.textContent = formatMoney(subtotal);
      if (bundleEl) bundleEl.textContent = formatMoney(bundlePrice);
      if (saveEl) saveEl.textContent = 'Du sparst: ' + formatMoney(save);

      var remaining = bundleSize - total;
      if (hintEl) {
        if (remaining > 0) {
          hintEl.textContent = remaining === 1
            ? 'Bitte wähl noch 1 Produkt aus.'
            : 'Bitte wähl noch ' + remaining + ' Produkte aus.';
          hintEl.hidden = false;
        } else {
          hintEl.hidden = true;
        }
      }

      if (ctaEl) {
        ctaEl.disabled = total !== bundleSize;
        if (ctaLabel) {
          ctaLabel.textContent = total === bundleSize
            ? 'Paket in den Warenkorb legen'
            : (remaining === 1 ? 'Noch 1 Produkt auswählen' : 'Noch ' + remaining + ' Produkte auswählen');
        }
      }

      cards.forEach(function (card) {
        var vid = card.dataset.variantId;
        var maxQty = getMaxQty(card);
        var sel = selection[vid];
        var currentQty = sel ? sel.qty : 0;

        if (sel && sel.qty > 0) {
          card.classList.add('is-selected');
          card.classList.remove('is-disabled');
          var badge = card.querySelector('[data-qty]');
          var stepNum = card.querySelector('[data-stepnum]');
          if (badge) badge.textContent = String(sel.qty);
          if (stepNum) stepNum.textContent = String(sel.qty);
        } else {
          card.classList.remove('is-selected');
          if (total >= bundleSize) card.classList.add('is-disabled');
          else card.classList.remove('is-disabled');
        }

        // Disable + button when card reached its stock limit
        var plusBtn = card.querySelector('[data-step="1"]');
        if (plusBtn) {
          plusBtn.disabled = currentQty >= maxQty;
        }
        // Disable the initial "Auswählen" button when stock is 0
        var selectBtn = card.querySelector('[data-select]');
        if (selectBtn && maxQty <= 0) {
          selectBtn.disabled = true;
        }
      });
    }

    function addOne(card) {
      if (totalQty() >= bundleSize) return;
      var vid = card.dataset.variantId;
      var maxQty = getMaxQty(card);
      var currentQty = selection[vid] ? selection[vid].qty : 0;
      if (currentQty >= maxQty) return;
      if (!selection[vid]) {
        selection[vid] = {
          qty: 0,
          price: parseInt(card.dataset.price, 10),
          title: card.dataset.title,
        };
      }
      selection[vid].qty += 1;
      render();
    }
    function removeOne(card) {
      var vid = card.dataset.variantId;
      if (!selection[vid] || selection[vid].qty <= 0) return;
      selection[vid].qty -= 1;
      if (selection[vid].qty === 0) delete selection[vid];
      render();
    }

    cards.forEach(function (card) {
      var selBtn = card.querySelector('[data-select]');
      var stepperBtns = card.querySelectorAll('[data-step]');
      if (selBtn) {
        selBtn.addEventListener('click', function () {
          addOne(card);
        });
      }
      stepperBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var dir = parseInt(btn.dataset.step, 10);
          if (dir > 0) addOne(card); else removeOne(card);
        });
      });
    });

    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        if (totalQty() !== bundleSize) return;
        submitBundle();
      });
    }

    function isThemeEditorPreview() {
      try {
        if (window.Shopify && window.Shopify.designMode) return true;
      } catch (_) {}
      try {
        if (window.parent && window.parent !== window) return true;
      } catch (_) {}
      return false;
    }

    function submitBundle() {
      ctaEl.disabled = true;
      if (spinner) spinner.hidden = false;
      if (ctaLabel) ctaLabel.textContent = 'Wird hinzugefügt …';

      var bundleId = 'rb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var items = Object.keys(selection).map(function (vid) {
        return {
          id: parseInt(vid, 10),
          quantity: selection[vid].qty,
          properties: {
            _bundle_id: bundleId,
            _bundle_type: bundleType,
            _bundle_discount: discountPct + '%',
          },
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          var dest = '/cart';
          if (discountCode && !isThemeEditorPreview()) {
            dest = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
          }
          window.location.href = dest;
        })
        .catch(function (err) {
          if (spinner) spinner.hidden = true;
          ctaEl.disabled = false;
          if (ctaLabel) ctaLabel.textContent = 'Paket in den Warenkorb legen';
          alert('Leider konnten nicht alle Produkte hinzugefügt werden. Bitte versuch es erneut.\n' + (err && err.description ? err.description : ''));
        });
    }

    render();
  }
})();
